import React from 'react'

const withAdditionalProps = (Component, additionalProps) => {
  const Wrapped = props => <Component {...additionalProps} {...props} />

  return Wrapped
}

export default withAdditionalProps
